import React, { FC } from 'react';

export const NotFoundIcon: FC = () => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="346.727" height="130.512" viewBox="0 0 346.727 130.512">
    <g id="Gruppe_1400" data-name="Gruppe 1400" transform="translate(-422.273 -483.752)">
      <path id="Pfad_2427" data-name="Pfad 2427"
            d="M60.246,399.713s-15.5-2.158-15.985,4.345c-.342,4.594,4.413,10.744,3.94,14.9-.323,2.823-8.014,3.557-8.68,7.4-.939,5.42,12.156,16.293,13.258,17.564,34.965,40.319,334.715,10.361,333.417-7.281-.22-2.983-8.934-4.067-8.914-8.841.019-4.488,7.732-5.713,7.95-10.4.281-6.066-12.157-14.331-20.477-18.2C305.429,371.584,120.517,411.38,60.246,399.713Z"
            transform="translate(382.8 150.269)" fill="#fff"/>
      <g id="Gruppe_1381" data-name="Gruppe 1381" transform="translate(686 533.78)">
        <rect id="Rechteck_1711" data-name="Rechteck 1711" width="32.733" height="5.684"
              transform="translate(1.136 36.719)" fill="#fff"/>
        <path id="Pfad_2442" data-name="Pfad 2442" d="M149.294,278.544l1.372-1.078,5.488-.588,8.232,35.036-23.57.294Z"
              transform="translate(-135.467 -276.273)" fill="#fff"/>
        <path id="Pfad_2443" data-name="Pfad 2443" d="M149.219,278.751H155.3l8.82,34.84-24.452.49Z"
              transform="translate(-134.706 -277.51)" fill="#fff"/>
        <rect id="Rechteck_1712" data-name="Rechteck 1712" width="15.301" height="3.4"
              transform="translate(9.996 17.158)" fill="#9dcff3"/>
        <rect id="Rechteck_1713" data-name="Rechteck 1713" width="19.552" height="3.4"
              transform="translate(7.738 25.708)" fill="#9dcff3"/>
        <path id="Pfad_2444" data-name="Pfad 2444"
              d="M158.334,381.4v4.651H126.78V381.4h31.554m1.7-1.7H125.08v8.051h34.954V379.7Z"
              transform="translate(-125.08 -344.139)"/>
        <path id="Pfad_2445" data-name="Pfad 2445"
              d="M164.148,312.275H137.96l9.448-37.177h7.6Zm-24-1.7h21.833l-8.3-33.777H148.73Z"
              transform="translate(-133.581 -275.098)"/>
      </g>
      <g id="Gruppe_1399" data-name="Gruppe 1399" transform="translate(703.494 546.026)">
        <rect id="Rechteck_1711-2" data-name="Rechteck 1711" width="32.733" height="5.684"
              transform="translate(1.136 36.719)" fill="#fff"/>
        <path id="Pfad_2442-2" data-name="Pfad 2442" d="M149.294,278.544l1.372-1.078,5.488-.588,8.232,35.036-23.57.294Z"
              transform="translate(-135.467 -276.273)" fill="#fff"/>
        <path id="Pfad_2443-2" data-name="Pfad 2443" d="M149.219,278.751H155.3l8.82,34.84-24.452.49Z"
              transform="translate(-134.706 -277.51)" fill="#fff"/>
        <rect id="Rechteck_1712-2" data-name="Rechteck 1712" width="15.301" height="3.4"
              transform="translate(9.996 17.158)" fill="#9dcff3"/>
        <rect id="Rechteck_1713-2" data-name="Rechteck 1713" width="19.552" height="3.4"
              transform="translate(7.738 25.708)" fill="#9dcff3"/>
        <path id="Pfad_2444-2" data-name="Pfad 2444"
              d="M158.334,381.4v4.651H126.78V381.4h31.554m1.7-1.7H125.08v8.051h34.954V379.7Z"
              transform="translate(-125.08 -344.139)"/>
        <path id="Pfad_2445-2" data-name="Pfad 2445"
              d="M164.148,312.275H137.96l9.448-37.177h7.6Zm-24-1.7h21.833l-8.3-33.777H148.73Z"
              transform="translate(-133.581 -275.098)"/>
      </g>
      <g id="Gruppe_1382" data-name="Gruppe 1382" transform="translate(59.063 484.037)">
        <path id="Pfad_2446" data-name="Pfad 2446"
              d="M437.115,92.186c-.455-8.841-3.355-14.726-9.511-16.679a10.51,10.51,0,0,0-2.14-.98l0,0-.013,0a8.859,8.859,0,0,0-7.419.983c-8.132,1.517-12.7,7.727-13.262,19.2-4.3,5.3-4.6,8.673,0,9.677l10.811,1.442c3.974.677,8.568-.871,13.676-4.268,4.641-1.755,7.768-3.586,8.6-4.9C439.43,94.465,439.2,92.965,437.115,92.186Z"
              transform="translate(-0.923 -1.549)" fill="#fff"/>
        <path id="Pfad_2447" data-name="Pfad 2447"
              d="M438.383,121.5l1.017,1.656-1.293,4.031-7.288,3.534-5.963,3.313-7.012.939-13.748-1.932-1.822-2.706,2.153-4.884.828-.8,4.693,3.9,8.337,1.342h5.466l8.779-2.623,4.521-3.617"
              transform="translate(-1.441 -30.79)" fill="#cdecfb"/>
        <path id="Pfad_2448" data-name="Pfad 2448"
              d="M439.182,91.836A3.1,3.1,0,0,0,437.5,90c-.6-9.252-3.977-14.941-10.038-16.917a9.759,9.759,0,0,0-10.3-.032c-8.564,1.669-13.228,8.313-13.867,19.756-2.809,3.525-3.838,6.2-3.147,8.171.492,1.4,1.8,2.345,3.883,2.8l10.855,1.451a11.95,11.95,0,0,0,2.012.166c3.606,0,7.721-1.515,12.265-4.521,2.311-.88,7.559-3.062,8.949-5.219C439.162,94.174,439.514,92.925,439.182,91.836ZM424.691,73.91c-6.859,3.3-11.272,10.266-13.135,20.753l-1.056-.29c-.708-5.518,1.586-11.421,7.641-19.677A7.845,7.845,0,0,1,424.691,73.91Zm-9.522,1.657c-5.341,7.732-7.314,13.563-6.552,19.175a1.736,1.736,0,0,0,1.262,1.447l2.062.565a1.082,1.082,0,0,0,1.352-.874c1.812-11.29,6.325-18.131,13.786-20.906,5.265,1.826,8.058,6.923,8.53,15.567-1.079,4.283-7.821,8.288-18.756,7.723-6.486-.334-11.258-2.448-11.659-5.151C405.684,83.536,408.956,77.768,415.169,75.568Zm21.366,18.99-.032.047c-.55.873-3.008,2.579-8.124,4.514l-.1.038-.09.06c-5.031,3.345-9.4,4.73-13.019,4.116L404.4,101.9c-1.369-.305-2.192-.828-2.447-1.555-.277-.791-.108-2.322,1.981-5.218,1.693,2.806,6.419,4.725,12.822,5.055q.921.048,1.846.048a32.211,32.211,0,0,0,11.053-1.837c3.841-1.453,6.4-3.627,7.48-6.335a.847.847,0,0,1,.215.341C437.491,92.86,437.2,93.628,436.535,94.558Z"
              fill="#000222"/>
      </g>
      <g id="Gruppe_1397" data-name="Gruppe 1397" transform="translate(-473.481 330.461)">
        <rect id="Rechteck_1714" data-name="Rechteck 1714" width="10.463" height="53.451"
              transform="translate(1012.2 198.492)" fill="#fff"/>
        <rect id="Rechteck_1735" data-name="Rechteck 1735" width="10.463" height="53.451"
              transform="translate(1039.2 198.492)" fill="#fff"/>
        <rect id="Rechteck_1736" data-name="Rechteck 1736" width="10.463" height="53.451"
              transform="translate(1066.2 198.492)" fill="#fff"/>
        <rect id="Rechteck_1737" data-name="Rechteck 1737" width="10.463" height="53.451"
              transform="translate(1092.2 198.492)" fill="#fff"/>
        <rect id="Rechteck_1738" data-name="Rechteck 1738" width="10.463" height="53.451"
              transform="translate(1119.2 198.492)" fill="#fff"/>
        <g id="Gruppe_1386" data-name="Gruppe 1386" transform="translate(1114.829 153.291)">
          <rect id="Rechteck_1715" data-name="Rechteck 1715" width="9.25" height="1.973"
                transform="translate(4.844 45.985)" fill="#b0b0ae"/>
          <rect id="Rechteck_1716" data-name="Rechteck 1716" width="9.25" height="1.973"
                transform="translate(4.844 85.268)" fill="#b0b0ae"/>
          <path id="Pfad_2449" data-name="Pfad 2449"
                d="M1304.58,266.816v52.1h-7.891v-52.1h7.891m1.973-1.973h-11.836V320.89h11.836V264.843Z"
                transform="translate(-1291.166 -220.833)"/>
          <path id="Pfad_2450" data-name="Pfad 2450"
                d="M1304.58,187.923v6.052h-7.891v-6.052h7.891m1.973-1.973h-11.836v10h11.836v-10Z"
                transform="translate(-1291.166 -173.065)"/>
          <g id="Gruppe_1385" data-name="Gruppe 1385" transform="translate(0)">
            <circle id="Ellipse_102" data-name="Ellipse 102" cx="9.469" cy="9.469" r="9.469" transform="translate(0)"
                    fill="#fff"/>
            <path id="Pfad_2451" data-name="Pfad 2451"
                  d="M1295.186,155.264a7.5,7.5,0,1,1-7.5,7.5,7.5,7.5,0,0,1,7.5-7.5m0-1.973a9.469,9.469,0,1,0,9.469,9.469,9.468,9.468,0,0,0-9.469-9.469Z"
                  transform="translate(-1285.717 -153.291)"/>
          </g>
          <circle id="Ellipse_103" data-name="Ellipse 103" cx="4.204" cy="4.204" r="4.204"
                  transform="translate(5.265 5.265)" fill="#3b69b0"/>
        </g>
        <g id="Gruppe_1387" data-name="Gruppe 1387" transform="translate(1003.595 174.2)">
          <rect id="Rechteck_1717" data-name="Rechteck 1717" width="134.511" height="25.073" transform="translate(0)"
                fill="#fff"/>
          <path id="Pfad_2452" data-name="Pfad 2452"
                d="M1136.046,208.264v21.127H1006V208.264h130.042m2.235-1.973H1003.769v25.073H1138.28V206.291Z"
                transform="translate(-1003.769 -206.291)"/>
        </g>
        <rect id="Rechteck_1718" data-name="Rechteck 1718" width="9.25" height="1.973"
              transform="translate(1012.778 199.276)" fill="#b0b0ae"/>
        <g id="Gruppe_1389" data-name="Gruppe 1389" transform="translate(1034.762 153.291)">
          <rect id="Rechteck_1719" data-name="Rechteck 1719" width="9.25" height="1.973"
                transform="translate(4.844 45.985)" fill="#b0b0ae"/>
          <rect id="Rechteck_1720" data-name="Rechteck 1720" width="9.25" height="1.973"
                transform="translate(4.844 85.268)" fill="#b0b0ae"/>
          <path id="Pfad_2453" data-name="Pfad 2453"
                d="M1101.632,266.816v52.1h-7.891v-52.1h7.891m1.973-1.973h-11.836V320.89H1103.6V264.843Z"
                transform="translate(-1088.218 -220.833)"/>
          <path id="Pfad_2454" data-name="Pfad 2454"
                d="M1101.632,187.923v6.052h-7.891v-6.052h7.891m1.973-1.973h-11.836v10H1103.6v-10Z"
                transform="translate(-1088.218 -173.065)"/>
          <g id="Gruppe_1388" data-name="Gruppe 1388" transform="translate(0)">
            <circle id="Ellipse_104" data-name="Ellipse 104" cx="9.469" cy="9.469" r="9.469" transform="translate(0)"
                    fill="#fff"/>
            <path id="Pfad_2455" data-name="Pfad 2455"
                  d="M1092.238,155.264a7.5,7.5,0,1,1-7.5,7.5,7.5,7.5,0,0,1,7.5-7.5m0-1.973a9.469,9.469,0,1,0,9.469,9.469,9.469,9.469,0,0,0-9.469-9.469Z"
                  transform="translate(-1082.769 -153.291)"/>
          </g>
          <circle id="Ellipse_105" data-name="Ellipse 105" cx="4.204" cy="4.204" r="4.204"
                  transform="translate(5.265 5.265)" fill="#3b69b0"/>
        </g>
        <g id="Gruppe_1391" data-name="Gruppe 1391" transform="translate(1061.382 153.291)">
          <rect id="Rechteck_1721" data-name="Rechteck 1721" width="9.25" height="1.973"
                transform="translate(4.844 45.985)" fill="#b0b0ae"/>
          <rect id="Rechteck_1722" data-name="Rechteck 1722" width="9.25" height="1.973"
                transform="translate(4.844 85.268)" fill="#b0b0ae"/>
          <path id="Pfad_2456" data-name="Pfad 2456"
                d="M1169.106,266.816v52.1h-7.89v-52.1h7.89m1.973-1.973h-11.836V320.89h11.836V264.843Z"
                transform="translate(-1155.692 -220.833)"/>
          <path id="Pfad_2457" data-name="Pfad 2457"
                d="M1169.106,187.923v6.052h-7.89v-6.052h7.89m1.973-1.973h-11.836v10h11.836v-10Z"
                transform="translate(-1155.692 -173.065)"/>
          <g id="Gruppe_1390" data-name="Gruppe 1390">
            <circle id="Ellipse_106" data-name="Ellipse 106" cx="9.469" cy="9.469" r="9.469" transform="translate(0)"
                    fill="#fff"/>
            <path id="Pfad_2458" data-name="Pfad 2458"
                  d="M1159.711,155.264a7.5,7.5,0,1,1-7.5,7.5,7.5,7.5,0,0,1,7.5-7.5m0-1.973a9.469,9.469,0,1,0,9.469,9.469,9.468,9.468,0,0,0-9.469-9.469Z"
                  transform="translate(-1150.243 -153.291)"/>
          </g>
          <circle id="Ellipse_107" data-name="Ellipse 107" cx="4.204" cy="4.204" r="4.204"
                  transform="translate(5.265 5.265)" fill="#3b69b0"/>
        </g>
        <g id="Gruppe_1393" data-name="Gruppe 1393" transform="translate(1088.002 153.291)">
          <rect id="Rechteck_1723" data-name="Rechteck 1723" width="9.25" height="1.973"
                transform="translate(4.844 45.985)" fill="#b0b0ae"/>
          <rect id="Rechteck_1724" data-name="Rechteck 1724" width="11.1" height="2.367"
                transform="translate(3.919 84.676)" fill="#b0b0ae"/>
          <path id="Pfad_2459" data-name="Pfad 2459"
                d="M1236.58,266.816v52.1h-7.891v-52.1h7.891m1.973-1.973h-11.836V320.89h11.836V264.843Z"
                transform="translate(-1223.166 -220.833)"/>
          <path id="Pfad_2460" data-name="Pfad 2460"
                d="M1236.58,187.923v6.052h-7.891v-6.052h7.891m1.973-1.973h-11.836v10h11.836v-10Z"
                transform="translate(-1223.166 -173.065)"/>
          <g id="Gruppe_1392" data-name="Gruppe 1392">
            <circle id="Ellipse_108" data-name="Ellipse 108" cx="9.469" cy="9.469" r="9.469" transform="translate(0)"
                    fill="#fff"/>
            <path id="Pfad_2461" data-name="Pfad 2461"
                  d="M1227.186,155.264a7.5,7.5,0,1,1-7.5,7.5,7.5,7.5,0,0,1,7.5-7.5m0-1.973a9.469,9.469,0,1,0,9.468,9.469,9.468,9.468,0,0,0-9.468-9.469Z"
                  transform="translate(-1217.717 -153.291)"/>
          </g>
          <circle id="Ellipse_109" data-name="Ellipse 109" cx="4.204" cy="4.204" r="4.204"
                  transform="translate(5.265 5.265)" fill="#3b69b0"/>
        </g>
        <rect id="Rechteck_1725" data-name="Rechteck 1725" width="9.25" height="1.973"
              transform="translate(1012.778 238.558)" fill="#b0b0ae"/>
        <g id="Gruppe_1395" data-name="Gruppe 1395" transform="translate(1007.934 153.291)">
          <path id="Pfad_2462" data-name="Pfad 2462"
                d="M1033.632,266.816v52.1h-7.891v-52.1h7.891m1.973-1.973h-11.836V320.89H1035.6V264.843Z"
                transform="translate(-1020.218 -220.833)"/>
          <path id="Pfad_2463" data-name="Pfad 2463"
                d="M1033.632,187.923v6.052h-7.891v-6.052h7.891m1.973-1.973h-11.836v10H1035.6v-10Z"
                transform="translate(-1020.218 -173.065)"/>
          <g id="Gruppe_1394" data-name="Gruppe 1394" transform="translate(0)">
            <circle id="Ellipse_110" data-name="Ellipse 110" cx="9.469" cy="9.469" r="9.469" transform="translate(0)"
                    fill="#fff"/>
            <path id="Pfad_2464" data-name="Pfad 2464"
                  d="M1024.238,155.264a7.5,7.5,0,1,1-7.5,7.5,7.5,7.5,0,0,1,7.5-7.5m0-1.973a9.469,9.469,0,1,0,9.469,9.469,9.469,9.469,0,0,0-9.469-9.469Z"
                  transform="translate(-1014.769 -153.291)"/>
          </g>
          <circle id="Ellipse_111" data-name="Ellipse 111" cx="4.204" cy="4.204" r="4.204"
                  transform="translate(5.265 5.265)" fill="#3b69b0"/>
        </g>
        <g id="Gruppe_1396" data-name="Gruppe 1396" transform="translate(1003.481 221.124)">
          <rect id="Rechteck_1726" data-name="Rechteck 1726" width="134.625" height="17.419" transform="translate(0 0)"
                fill="#fff"/>
          <path id="Pfad_2465" data-name="Pfad 2465"
                d="M1135.869,327.2v13.474H1005.718V327.2h130.151m2.237-1.973H1003.481v17.419h134.625V325.228Z"
                transform="translate(-1003.481 -325.228)"/>
        </g>
        <rect id="Rechteck_1727" data-name="Rechteck 1727" width="14.992" height="13.486"
              transform="translate(1023.321 223.076)" fill="#cdecfb"/>
        <rect id="Rechteck_1728" data-name="Rechteck 1728" width="14.784" height="13.486"
              transform="translate(1076.768 223.076)" fill="#cdecfb"/>
        <rect id="Rechteck_1729" data-name="Rechteck 1729" width="15.189" height="13.486"
              transform="translate(1103.191 223.076)" fill="#cdecfb"/>
        <rect id="Rechteck_1730" data-name="Rechteck 1730" width="14.631" height="13.486"
              transform="translate(1050.148 223.076)" fill="#cdecfb"/>
        <rect id="Rechteck_1731" data-name="Rechteck 1731" width="14.875" height="21.127"
              transform="translate(1103.505 176.173)" fill="#cdecfb"/>
        <rect id="Rechteck_1732" data-name="Rechteck 1732" width="14.784" height="21.127"
              transform="translate(1076.768 176.173)" fill="#cdecfb"/>
        <rect id="Rechteck_1733" data-name="Rechteck 1733" width="14.731" height="21.127"
              transform="translate(1050.202 176.173)" fill="#cdecfb"/>
        <rect id="Rechteck_1734" data-name="Rechteck 1734" width="14.878" height="21.127"
              transform="translate(1023.435 176.173)" fill="#cdecfb"/>
      </g>
    </g>
  </svg>);
};
